<script lang="ts">
	import { createEventDispatcher } from 'svelte'
	import { get } from 'svelte/store'

	import { account } from '$lib/stores/account/account'
	import { compareAccountPlan } from '$lib/stores/account/manager'
    import type { SubscriptionTableInfo } from '$lib/stores/subscription_table_info/types'
	import type { SubscriptionFeature, SubscriptionPlanFeature } from '$lib/types/subscription_types'

	import Product from './ProductV4.svelte'
	import SubscribeIntervalSwitch from './SubscribeIntervalSwitch.svelte'

	export let configMode = false
	export let subscriptionTableInfo: SubscriptionTableInfo[] = []
	export let subscriptionPlanFeatures: SubscriptionPlanFeature[] = []
	export let subscriptionFeatures: SubscriptionFeature[] = []
	// export let applyCoupon = false
	export let tougleDiscountOn = false

	const dispatch = createEventDispatcher()

	let optionsInteval: string[] = []
	let currentInteval = ''
	let subscriptionTableInterval: SubscriptionTableInfo[] = []

	let currency_text = ''

	$: setTableInfo(subscriptionTableInfo)
	$: {
		subscriptionTableInterval = subscriptionTableInfo.filter(function (el) {
			return el.recurring_interval == currentInteval
		})
		// subscriptionIntervalCols = subscriptionTableInterval.length
	}

	function isProductDisabled(product: SubscriptionTableInfo): boolean {
		if (configMode) return false

		let acc = get(account)

		if (acc.stripe_subscription_status != 'active') return false

		if (compareAccountPlan(product.sub_plan_key, acc.subscription_plan_key) == 0) {
			if (product.recurring_interval == acc.stripe_subscription_plan_interval) return true
		}

		return false
	}

	function buyText(product: SubscriptionTableInfo) {
		let acc = get(account)

		if (acc.stripe_subscription_status != 'active') return 'Buy Now'

		if (compareAccountPlan(product.sub_plan_key, acc.subscription_plan_key) == 0) {
			if (product.recurring_interval == acc.stripe_subscription_plan_interval) return 'Active'
			else if (product.recurring_interval > acc.stripe_subscription_plan_interval) return 'Upgrade'
			else return 'Downgrade'
		} else if (compareAccountPlan(product.sub_plan_key, acc.subscription_plan_key) < 0) {
			return 'Downgrade'
		} else if (compareAccountPlan(product.sub_plan_key, acc.subscription_plan_key) > 0) {
			return 'Upgrade'
		}

		return 'Buy Now'
	}
	function setTableInfo(response: SubscriptionTableInfo[]) {
		subscriptionTableInfo = response
		if (response.length == 0) {
			optionsInteval = []
			setCurrentInterval('')
			return
		}
		currency_text = response[0].currency_text

		optionsInteval = subscriptionTableInfo
			.map((item) => item.recurring_interval)
			.filter((value, index, self) => self.indexOf(value) === index)

		let defRecurringInterval = response[0].default_recurring_interval
		if (!defRecurringInterval) defRecurringInterval = response[0].recurring_interval
		setCurrentInterval(defRecurringInterval)
	}

	function setCurrentInterval(interval: string) {
		currentInteval = interval
	}

	async function handleSubscribe(event: CustomEvent) {
		let eventInfo = event.detail
		// console.log('SubscribeTable.svelte - Stripe subscribe clicked!', eventInfo)
		dispatch('subscribe', eventInfo)
		return
	}
</script>

<!-- Subscription Table --------------------- -->
<div class="max-w-7xl mx-auto pb-6 sm:px-6 lg:px-6">
	<div class="space-y-4 sm:space-y-0 mt-2 grid place-items-center">
		<div class="inline-flex p-2">
			{#each optionsInteval as interval}
				<!-- <Button
					data-test-id="subscription_button_interval_{interval}"
					class="!mx-1 !h-14 {currentInteval == interval ? '!text-black' : ''}"
					type="secondary"
					on:click={() => setCurrentInterval(interval)}
				>
					{getIntervalDisplayName(interval)}<br />
					{getIntervalDisplayComment(interval)}
				</Button> -->
				<SubscribeIntervalSwitch
					{subscriptionTableInfo}
					{interval}
					selected={currentInteval == interval}
					on:interval_selected={() => setCurrentInterval(interval)}
				/>
			{/each}
		</div>
	</div>

	<div class="products">
		{#each subscriptionTableInterval as product (product.price_id)}
			<Product
				{currency_text}
				{subscriptionPlanFeatures}
				{subscriptionFeatures}
				data={product}
				discountOn={tougleDiscountOn}
				disabled={isProductDisabled(product)}
				buyText={buyText(product)}
				on:subscribe={handleSubscribe}
			/>
		{/each}
	</div>
</div>

<style type="postcss">
	.products {
		display: grid;
		grid-template-columns: repeat(1, minmax(0, 1fr));
		margin-top: 1.5rem /* 24px */;
		gap: 1.5rem; /*24px; */
	}
	@media (min-width: 850px) {
		.products {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}
	}
	@media (min-width: 1180px) {
		.products {
			display: grid;
			grid-template-columns: repeat(3, minmax(0, 1fr));
			max-width: 56rem /* 896px */;
			margin-left: auto;
			margin-right: auto;
		}
	}
</style>
